import { CONFIRMED_GET_ASSIGNED_HISTORY } from "../types/LeadHistoryType";

const initialState = {
  assignedHistory: [],
  num_rows: 0,
  loading: false,
  error: null
};

export default function LeadHistoryReducer(state = initialState, action) {
  switch (action.type) {

    case CONFIRMED_GET_ASSIGNED_HISTORY:
      return {
        ...state,
        assignedHistory: action.payload.assignedHistory,
        num_rows: action.payload.num_rows
      };

    default:
      return state;
  }
}
